export default __webpack_public_path__ + "static/media/select.9af8562d.svg";